import { SignupTemplate } from '../../../templates';

export default function SignupPage() {
  return <SignupTemplate />;
}
